<template>
    <div class="tab-pane fade show active" id="pricing" role="tabpanel" aria-labelledby="seo-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <product-lang-toggle></product-lang-toggle>
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>Marketing</h3>
                </div>
            </div>
            <div class="row">
                <div v-for="(field, index) in productMarketing.items.groupItems" :key="index" :class="field.column">
                    <h3 v-if="field.type === 'header'">{{field.label}}</h3>
                    <div v-if="field.type == 'text'">
                        <label for="">
                            <span class="label-title">{{field.label}}</span>
                            <span v-if="field.required" class="required-field">*</span>
                        </label>
                        <input-text v-model="field.value" :field-data="field"></input-text>
                    </div>
                    <div v-if="field.type == 'textarea'">
                        <label for="">
                            <span class="label-title">{{field.label}}</span>
                            <span v-if="field.required" class="required-field">*</span>
                        </label>
                        <input-textarea v-model="field.value" :field-data="field"></input-textarea>
                    </div>
                    <div v-if="field.type == 'checkbox'">
                        <input-checkbox v-model="field.value" :field-data="field"></input-checkbox>
                    </div>
                    <hr class="form-line-break" v-if="field.type == 'horizontal-rule'">
                    <div v-if="field.type === 'select' || field.type === 'multiselect' " class="form-group">
                        <label for="">{{field.label}}</label>
                        <select2 v-model="field.value"  :name="field.name" class="attribute_select" :config="{placeholder: '', width: '100%'}">
                            <option value="">Choose....</option>
                            <option v-for="option in field.options" :value="option.id" :selected="option.selected">{{option.name}}</option>
                        </select2>
                    </div>
                    <div v-if="field.type == 'repeater'">
                        <form-input-repeater :repeater-name="repeaterName" :inputs.sync="field.options" :repeater-button-label="repeaterButtonLabel">Add New Benefit Field</form-input-repeater>
                    </div>
                    <div class="form-group" v-if="field.type === 'date' || field.type === 'datetime'">
                        <label for="">{{field.label}}</label>
                        <div class="input-group date">
                            <input-datetime-picker v-if="field.type === 'date'" format="YYYY-MM-DD" :config="datepickerOptions" :field-data="field" v-model="field.value"></input-datetime-picker>
                            <input-datetime-picker format="YYYY-MM-DD HH:mm:ss" :config="datepickerOptions" :field-data="field" v-model="field.value" v-if="field.type === 'datetime'"></input-datetime-picker>
                            <div class="input-group-append">
                                <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                            </div>
                        </div>
                    </div>
                    <form-wysiwyg v-if="field.type === 'wysiwyg'"  :model.sync="field.value"></form-wysiwyg>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-primary" @click="saveProductMarketingData()">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
var base_url = window.location.protocol + "//" + window.location.host

import Vue from 'vue';
import VueEvents from 'vue-events'
import axios from 'axios'
import select2 from 'select2';

import InputText from '../form/form-text.vue';
import FormInputRepeater from '../form/form-input-repeater';
import FormWYSIWYG from '../form/form-wysiwyg';
import FormDateTimePicker from '../form/form-datetime.vue';
import productLangToggle from './product-language-select.vue';

Vue.use(VueEvents)

export default {
    name: 'product-marketing',
    props: [],
    components:{
        'input-text': InputText,
        'input-datetime-picker' : FormDateTimePicker,
        'form-input-repeater': FormInputRepeater,
        'form-wysiwyg': FormWYSIWYG,
        'product-lang-toggle': productLangToggle,
    },
    data() {
        return {
            repeaterName: 'Benefits',
            repeaterButtonLabel: 'Add New Benefit Field',
            uiStates: {
                errorMessage: null,
                showLoading: true,
            },
            productMarketing: {
                items: {
                    groupItems: []
                }
            }
        }
    },
    mounted() {
        if( this.$parent.loadedPanelData.marketing) {
            this.productMarketing = this.$parent.productMarketing;
            this.uiStates.showLoading = false;
        }
        if( !this.$parent.loadedPanelData.marketing) {
            this.loadProductMarketing();
            this.$parent.loadedPanelData.marketing = true;
        }
    },
     watch: {
         '$parent.languages.active': 'checkLangChange',
     },
    methods: {
        checkLangChange () {
             this.uiStates.showLoading = true;
             this.productMarketing = [];
             this.loadProductMarketing();
        },
        loadProductMarketing: function() {
            axios.get(base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/marketing/' + this.$parent.languages.active, {

            })
            .then(function(response) {
                this.productMarketing = response.data;
                this.$parent.productMarketing = this.productMarketing;
                this.uiStates.showLoading = false;
            }.bind(this))
            .catch(function(error) {
                this.uiStates.showLoading = false;
                this.uiStates.errorMessage = error.response.data.message;
            }.bind(this));
        },
        saveProductMarketingData: function() {
            this.uiStates.showLoading = true;
            axios.put(base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/marketing/' + this.$parent.languages.active, {
                'productMarketing' : this.productMarketing,
            })
            .then(function(response) {
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = "Product successfully saved";
                this.uiStates.showLoading = false;
            }.bind(this))
            .catch(function(error) {
                this.uiStates.showLoading = false;
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this));
        },
    },
};
</script>

<style scoped lang="scss">

</style>